var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsKeyboardArrowDownRoundedDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:keyboard-arrow-down-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 21C16.1913 21 16.3769 20.9618 16.5568 20.8855C16.7366 20.8091 16.8859 20.7074 17.0045 20.5801L23.6054 13.5572C23.8685 13.2773 24 12.9211 24 12.4885C24 12.056 23.8685 11.6997 23.6054 11.4198C23.3423 11.1399 23.0075 11 22.6009 11C22.1943 11 21.8595 11.1399 21.5964 11.4198L16 17.374L10.4036 11.4198C10.1405 11.1399 9.80568 11 9.3991 11C8.99253 11 8.6577 11.1399 8.39462 11.4198C8.13154 11.6997 8 12.056 8 12.4885C8 12.9211 8.13154 13.2773 8.39462 13.5572L14.9955 20.5801C15.139 20.7328 15.2945 20.8412 15.4619 20.9053C15.6293 20.9694 15.8087 21.001 16 21Z",
    fill: "#4E0AA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsKeyboardArrowDownRoundedDownBlue);
export default __webpack_public_path__ + "static/media/material-symbols_keyboard-arrow-down-rounded_down_blue.cdd9617d7c78b88f2e6e67dd38e67b51.svg";
export { ForwardRef as ReactComponent };